import { generateClient } from "aws-amplify/api";
import { updateLesson } from "../../../graphql/mutations";
import { getLesson } from "../../../graphql/queries";
import { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LessonForm from "../common/LessonForm";
import { Box, Grid2, CircularProgress } from "@mui/material";

const UpdateLesson = () => {
  const initialFormState = useMemo(() => ({
    title: "",
    description: "",
    content: "",
    order: 0,
    duration: 0,
    survey: "",
  }), []);
  const [lesson, setLesson] = useState(initialFormState);
  const [loading, setLoading] = useState(true);
  const client = useMemo(() => generateClient(), []);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchLesson = async () => {
      try {
        const result = await client.graphql({
          query: getLesson,
          variables: {
            id,
          },
        });
        const lesson = result.data.getLesson;
        setLesson(lesson);
      } catch (error) {
        console.error("Error fetching lesson:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLesson();
  }, [client, id]);

  const handleSave = async (lesson) => {
    try {
      const result = await client.graphql({
        query: updateLesson,
        variables: {
          input: {
            id: lesson.id,
            title: lesson.title,
            description: lesson.description,
            content: lesson.content,
            order: parseInt(lesson.order),
            duration: lesson.duration,
            survey: lesson.survey,
          },
        },
      });
      const updatedLesson = result.data.updateLesson;
      setLesson(updatedLesson);
      // Navigate to lessons page with success message
      navigate('/settings/lessons', { 
        state: { 
          successMessage: 'Lección actualizada exitosamente' 
        } 
      });
    } catch (error) {
      console.error("Error updating lesson:", error);
    }
  };

  return (
    <Box>
      <Grid2 container>
        {loading ? (
          <CircularProgress />
        ) : (
          <LessonForm
            initialFormState={lesson}
            onSave={handleSave}
            onBack={handleBack}
            title="Update Lesson"
          />
        )}
      </Grid2>
    </Box>
  );
};

export default UpdateLesson;